module.exports = __webpack_public_path__ + "img/Breaking_Bad_I_am_the_danger.aae58c58.jpg";